(() => {
  if (customElements.get('cart-bonus-progress')) return;
  const widgets = new Set();
  const tiers = [[50000, 5], [80000, 8], [100000, 10]];
  const rateFor = total => tiers.reduce((rate, tier) => total >= tier[0] ? tier[1] : rate, 0);
  let state;
  let generation = 0;
  let refreshTimer;
  let lastAnimatedTotal = 0;

  const update = cart => {
    if (!cart || !Number.isFinite(Number(cart.total_price))) return false;
    generation += 1;
    const next = { total: Math.max(0, Number(cart.total_price)), currency: cart.currency || state?.currency || 'EUR' };
    if (state?.total === next.total && state?.currency === next.currency) return true;
    state = next;
    widgets.forEach(widget => widget.render());
    return true;
  };
  const refresh = () => {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(async () => {
      const requestGeneration = ++generation;
      try {
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', { cache: 'no-store' });
        if (!response.ok) return;
        const cart = await response.json();
        if (requestGeneration === generation) update(cart);
      } catch (_) {}
    }, 60);
  };
  ['cart:updated', 'cart:refresh'].forEach(name => document.documentElement.addEventListener(name, event => {
    if (!update(event.detail?.cart)) refresh();
  }));
  window.addEventListener('pageshow', refresh);
  window.addEventListener('focus', refresh);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });

  customElements.define('cart-bonus-progress', class extends HTMLElement {
    connectedCallback() {
      this.strings = JSON.parse(this.querySelector('[data-bonus-strings]').textContent);
      this.fill = this.querySelector('[data-bonus-fill]');
      this.drawer = this.closest('cart-drawer');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      if (!state) state = { total: Number(this.dataset.cartTotal) || 0, currency: this.dataset.currency || 'EUR' };
      widgets.add(this);
      this.observer = new MutationObserver(() => { if (this.drawer.hasAttribute('open')) this.animateProgress(); });
      if (this.drawer) this.observer.observe(this.drawer, { attributes: true, attributeFilter: ['open'] });
      this.render();
      this.dataset.initialized = 'true';
    }
    disconnectedCallback() {
      widgets.delete(this);
      this.observer?.disconnect();
      this.animation?.cancel();
      clearTimeout(this.pulseTimer);
    }
    render() {
      const { total, currency } = state;
      const rate = rateFor(total);
      const format = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(cents / 100);
      this.dataset.cartTotal = String(total);
      this.dataset.cartRate = String(rate);
      this.querySelector('[data-bonus-total]').textContent = format(total);
      this.querySelector('[data-bonus-rate]').textContent = rate + ' %';
      this.querySelector('[data-bonus-amount]').textContent = format(Math.round(total * rate / 100));
      this.querySelector('[data-bonus-earned]').hidden = rate === 0;
      this.querySelectorAll('[data-bonus-tier]').forEach(tier => tier.classList.toggle('is-reached', total >= Number(tier.dataset.bonusTier)));
      this.querySelector('[role="progressbar"]').setAttribute('aria-valuenow', String(Math.min(1000, total / 100)));
      const next = tiers.find(tier => total < tier[0]);
      this.querySelector('[data-bonus-next]').textContent = next ? this.strings.next.replace('[amount]', format(next[0] - total)).replace('[rate]', next[1]) : this.strings.highest;
      if (this.drawer?.hasAttribute('open')) this.animateProgress();
      else this.fill.style.transform = 'scaleX(' + Math.min(1, lastAnimatedTotal / 100000) + ')';
    }
    animateProgress() {
      const total = state.total;
      const target = Math.min(1, total / 100000);
      const previousRate = rateFor(lastAnimatedTotal);
      const transform = getComputedStyle(this.fill).transform;
      const from = transform === 'none' ? 0 : new DOMMatrixReadOnly(transform).a;
      this.animation?.cancel();
      this.fill.style.transform = 'scaleX(' + target + ')';
      if (!this.motion.matches && total !== lastAnimatedTotal) {
        this.animation = this.fill.animate([{ transform: 'scaleX(' + from + ')' }, { transform: 'scaleX(' + target + ')' }], { duration: 650, easing: 'cubic-bezier(.22,.61,.36,1)' });
        if (rateFor(total) > previousRate) {
          this.classList.remove('is-unlocked');
          this.querySelectorAll('[data-bonus-tier]').forEach(tier => tier.classList.toggle('is-new-tier', Number(tier.dataset.bonusTier) <= total && Number(tier.dataset.bonusTier) > lastAnimatedTotal));
          this.classList.add('is-unlocked');
          clearTimeout(this.pulseTimer);
          this.pulseTimer = setTimeout(() => this.classList.remove('is-unlocked'), 900);
        }
      }
      lastAnimatedTotal = total;
    }
  });
})();
